import React, { useCallback, useRef, useState } from 'react';
import { FiPlay, FiPlusCircle, FiX } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { show } from 'store/modules/dialog/actions';
import api from 'services/api';
import { ColumnContent, Patrocinio, VinhetaPatrocinio } from './styles';
import { ThumbnailContainer } from 'styles/global';
import { Image } from 'pages/Chamada/styles';
import notfound from 'assets/semimagem.png';
import { BasePrograma, EmissoraOption, PatrocinioOption } from './store';

import TextArea from 'components/TextArea';
import AsyncSelectCreatable from 'components/AsyncSelectCreatable';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
import PlayerBaixa from 'components/PlayerBaixa';
import Input from 'components/Input';
import AppError from 'utils/AppError';

interface Props {
  formRef: React.RefObject<FormHandles>;
  patrocinios: PatrocinioOption[];
  setPatrocinios: React.Dispatch<React.SetStateAction<PatrocinioOption[]>>;
  setBasePrograma: React.Dispatch<
    React.SetStateAction<BasePrograma | undefined>
  >;
  basePrograma?: BasePrograma;
  loadComerciais: (value: any) => Promise<any>;
  asyncLoading: boolean;
}
export default function Vinheta(props: Props) {
  // USE STATE
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  /**
   * REDUX
   */
  const dispatch = useDispatch();

  // USE CALLBACK
  const loadBasePrograma = useCallback(
    async e => {
      try {
        if (e.key !== 'Enter' || !props.formRef.current) return;

        e.preventDefault(); // Avoid form submit

        const form = props.formRef.current;
        const duracao = Number(e.target.value);
        const programa = form.getFieldValue('programa');
        const emissoraIds = form.getFieldValue('emissora') || [];
        const emissora_id = Number(emissoraIds[0]) || null;

        const isDuracaoValida = duracao > 2 && duracao < 20;
        if (!isDuracaoValida || !programa)
          throw new Error('Duração ou programa inválidos');

        const response = await api.get('/baseprogramas', {
          params: { programa_id: programa, duracao, emissora_id },
        });

        const bases = response?.data || [];
        if (!response?.data)
          throw new Error('Falha de comunicação com o servidor');

        if (bases.length === 0) throw new Error(`Nenhuma base encontrada`);

        // Preenchendo a base da vinheta
        props.setBasePrograma({
          ...bases[0],
          emissora: bases[0].emissora?.nome || 'REDE',
          nome: bases[0].programa.mnemonico,
          locucao: bases[0].programa.locucaobase,
        });
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
          console.log(error);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
          console.log(error);
        }
        // Limpando a base da vinheta
        props.setBasePrograma({
          id: 0,
          nome: '',
          duracao: 0,
          locucao: '',
          emissora: '',
          preview_url: '',
          thumbnail_url: '',
        });
        // Limpando a locução base
        props.formRef.current?.clearField('locucaobase');
      }

      e.target.value = '';
    },
    [props.formRef],
  );

  /**
   * PLAYER
   */

  const handlePlayer = useCallback(
    preview_url => {
      if (preview_url) {
        setPlayer({
          open: !player.open,
          midia_url: preview_url,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  // fecha player
  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  return (
    <VinhetaPatrocinio>
      <section>
        <h5>Materiais para produção: </h5>
      </section>
      <ColumnContent columns="10fr 10fr 10fr 10fr 10fr 1fr">
        <Patrocinio>
          <div>
            <h4>{props.basePrograma?.programa?.mnemonico || 'Buscar base'}</h4>
            <Input
              placeholder="Informe a duração para busca da base"
              name="duracaobase"
              onKeyDown={e => loadBasePrograma(e)}
            />
          </div>
          {props.basePrograma && !!props.basePrograma.id && (
            <div>
              <ThumbnailContainer onClick={() => {}}>
                <Image
                  onClick={() => handlePlayer(props.basePrograma?.preview_url)}
                  src={props.basePrograma.thumbnail_url}
                  loader={<Spinner />}
                  unloader={<img src={notfound} alt="sem thumb" />}
                />

                <FiPlay className="icon_play" />
              </ThumbnailContainer>
              <div>
                <div className="dados">
                  <p>Programa: {props.basePrograma.nome}</p>
                  <p>Emissora: {props.basePrograma.emissora}</p>
                  <p>Duração: {props.basePrograma.duracao}s</p>
                </div>
              </div>
            </div>
          )}
          <TextArea
            placeholder="Locução da base do programa"
            name="locucaobase"
            errorField=""
            icon=""
          />
        </Patrocinio>
        {props.patrocinios.map((p, index) => (
          <Patrocinio>
            <div>
              <h4>{index + 1}º Patrocínio:</h4>
              <AsyncSelectCreatable
                searchable
                menuPlacement="top"
                name={`patrociniosvinhetas_${index}`}
                loadOptions={props.loadComerciais}
                placeholder="Digite o Código do Material"
                isValidNewOption={(value: string) =>
                  value.length >= 5 && value.length <= 6 && Number(value)
                }
                onChange={(value: PatrocinioOption) =>
                  props.setPatrocinios(prevState =>
                    prevState.map((prev, id) => (id === index ? value : prev)),
                  )
                }
                createOptionPosition="first"
                type="codmaterial"
                isClearable={false}
                isMulti={false}
                isLoading={props.asyncLoading}
                errorField=""
              />
            </div>
            {!p.__isNew__ && (
              <div>
                <ThumbnailContainer onClick={() => console.log('oi')}>
                  <Image
                    onClick={() => handlePlayer(p.preview_url)}
                    src={p.thumbnail_url || notfound}
                    loader={<Spinner />}
                    unloader={<img src={notfound} alt="sem thumb" />}
                  />

                  <FiPlay className="icon_play" />
                </ThumbnailContainer>
                <div className="dados">
                  <p>Cliente: {p.cliente}</p>
                  <p>Agência: {p.agencia}</p>
                  <p>Duração: {`${p.duracao} seg`}</p>
                </div>
              </div>
            )}
            <TextArea
              placeholder={`Locução do ${index + 1}º patrocínio`}
              name={`locucaopatrocinio_${index}`}
              errorField=""
              icon=""
            />
          </Patrocinio>
        ))}
        <div>
          {props.patrocinios.length < 4 && (
            <div>
              <Button
                type="button"
                fill
                color="font"
                round
                onClick={e => {
                  e.preventDefault();
                  props.setPatrocinios(prevState => [
                    ...prevState,
                    {
                      id: 0,
                      codmaterial: 0,
                      value: '',
                      label: '',
                      cliente: '',
                      agencia: '',
                      duracao: '0',
                      __isNew__: true,
                      ordem: 0,
                    },
                  ]);
                }}
              >
                <FiPlusCircle />
              </Button>
            </div>
          )}
          {props.patrocinios.length > 1 && (
            <div>
              <Button
                type="button"
                fill
                color="font"
                round
                onClick={e => {
                  e.preventDefault();
                  props.setPatrocinios(prevState => prevState.slice(0, -1));
                }}
              >
                <FiX />
              </Button>
            </div>
          )}
        </div>
      </ColumnContent>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </VinhetaPatrocinio>
  );
}
